import { deserializeSnakeCase } from "@/utils/snake-case-converter";
import { DjangoError } from "./l1-report/l1-report.types";

const baseUrl = process.env.NEXT_PUBLIC_CLEARWATT_BASE_API;

const apiClient = async (
    endpoint: string,
    { method = "GET", data = null, headers = {}, expectEmptyResponse = false },
) => {
    const url = `${baseUrl}${endpoint}`;
    const config = {
       method,
       headers: {
          "Content-Type": "application/json",
          ...headers,
       },
       body: data ? JSON.stringify(data) : undefined,
    };

    const response = await fetch(url, config);

    if (!response.ok) {
       const body = await response.json();
       const data = deserializeSnakeCase<DjangoError>(body);
       if (data.nonFieldErrors) {
          throw new Error(data.nonFieldErrors.join(", "));
       }
       if (data.error) {
          throw new Error(data.error);
       } else {
          throw new Error("Something went wrong.");
       }
    }

    // Si esperamos una respuesta vacía o tenemos un response 204 (No Content)
    // o la respuesta no tiene contenido, devolvemos null
    if (expectEmptyResponse || response.status === 204) {
       return null;
    }

    // Verificar si hay contenido antes de intentar parsear como JSON
    const contentLength = response.headers.get('content-length');
    if (contentLength === '0') {
       return null;
    }

    // Primero obtenemos el texto de la respuesta
    const text = await response.text();

    // Si el texto está vacío, devolvemos null
    if (!text.trim()) {
       return null;
    }

    // Intentamos parsear el texto como JSON
    try {
       return JSON.parse(text);
    } catch (error) {
       console.error('Error parsing JSON:', error);
       throw new Error('Failed to parse server response');
    }
};

export default apiClient;